import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { Qualification, QualificationContainerState } from './qualification';

const initialState: QualificationContainerState = {
  listQualifications: [],
};

export const slice = createSlice({
  name: SLICE_NAME,

  initialState,

  reducers: {
    setListQualifications: (state, action: PayloadAction<Qualification[]>) => {
      state.listQualifications = action.payload;
    },
  },
});

export const { setListQualifications } = slice.actions;

export default slice.reducer;
